import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

/**
 * Puts fields side by side on wider screens and stacks them on phones.
 * `columns` are CSS grid tracks, e.g. "1fr 1fr" or "2fr 1fr 1fr".
 */
export function FieldRow({ columns = '1fr 1fr', children }: { columns?: string; children: ReactNode }) {
  return <Box sx={{ display: 'grid', gap: 2.5, gridTemplateColumns: { xs: '1fr', sm: columns } }}>{children}</Box>;
}

/** A small heading inside a form, e.g. "Accounts contact". */
export function FormSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Box component="fieldset" sx={{ border: 0, p: 0, m: 0, display: 'grid', gap: 2.5 }}>
      <Box component="legend" sx={{ fontWeight: 600, fontSize: 16, mb: 2, p: 0 }}>{title}</Box>
      {children}
    </Box>
  );
}
